/**
 * Portrait lock (Jonny, 1 Oct 2026; replaces the GDD's landscape). CSS shows the rotate card when a phone is sideways.
 * Where the browser allows it (Android Chrome), the first tap also goes fullscreen and locks portrait.
 * iOS Safari has no lock API, so it relies on the rotate card alone.
 */
export function enablePortraitLock(target: HTMLElement): void {
  const onFirstTap = async () => {
    target.removeEventListener('pointerup', onFirstTap);
    if (!matchMedia('(pointer: coarse)').matches || !document.fullscreenEnabled) return;
    try {
      await document.documentElement.requestFullscreen({ navigationUI: 'hide' });
      const orientation = screen.orientation as ScreenOrientation & { lock?: (o: string) => Promise<void> };
      await orientation.lock?.('portrait');
    } catch {
      // Not allowed on this browser; the rotate card still covers portrait.
    }
  };
  target.addEventListener('pointerup', onFirstTap);
}
